import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";
export default function CtaWithChecklist({ data, className = "" }) {
  const appMode = process.env.APP_MODE;
  const link =
    appMode && typeof data?.cta?.href === "object"
      ? data.cta.href[appMode]
      : data?.cta?.href;
  const Article = () => {
    return (
      <>
        <article className="lg:maxw-sm text-md">
          <h3 className="fw-700 text-left text-md text-grey">{data.title}</h3>
          <p
            className="lg:mt-1.5 lg:pb-10 md:mb-5 md:mt-1.5 text-left text-md"
            dangerouslySetInnerHTML={{ __html: data.desc }}
          />
          {data.hasOwnProperty("cta") && (
            <a href={link} className="btn-secondary md:py-1 md:text-smx">
              {data.cta.text}
            </a>
          )}
          <style jsx>
            {`
              .btn-secondary {
                position: absolute;
                bottom: 80px;
              }
              @media (max-width: ${viewport.tablet.sm}) {
                .btn-secondary {
                  position: absolute;
                  bottom: 0px;
                  left: 0px;
                  width: 90% !important;
                  margin: 0px 20px 24px 20px;
                }
              }
            `}
          </style>
        </article>{" "}
      </>
    );
  };
  const List = () => {
    return (
      <ul className="list-with-icon md:mb-10 md:mt-3 md:pb-0 text-left text-smx">
        {data.list.map((item, index) => {
          return (
            <li key={index}>
              <span dangerouslySetInnerHTML={{ __html: item }} />
            </li>
          );
        })}
        <style jsx>
          {`
            .list-with-icon li {
              display: flex;
              margin-bottom: 12px;
            }
            @media (min-width: ${viewport.tablet.sm}) {
              .list-with-icon li {
                align-items: inherit;
              }
              .list-with-icon li:last-child {
                margin: 0px !important;
              }
              .list-with-icon > li::before {
                content: "";
                top: 0px;
                margin-right: 5px;
                width: 32px;
              }
            }
            @media (max-width: ${viewport.tablet.sm}) {
              .list-with-icon {
                padding-right: 4px;
                margin-bottom: 86px !important;
              }
              .list-with-icon > li::before {
                width: 40px;
                top: 3px;
                margin-right: 5px;
              }
            }
          `}
        </style>
      </ul>
    );
  };
  return (
    <section className={`highlight bg-light ${className}`}>
      <div className="container br-8 lg:pt-10 lg:pb-10 md:pr-2.5 md:pl-2.5 md:pt-2.5 md:pb-3 grid--default has-align-top bg-white pos-rel">
        <Article />
        <List />
      </div>
      <style jsx>
        {`
          .grid--default {
            padding-left: 100px;
            padding-right: 60px;
          }
        `}
      </style>
    </section>
  );
}
